import { toast as originalToast } from 'sonner';
import { openSupportDetails, supportStore } from './error-support';

// Keep existing call sites and success notifications intact. Decorate matching API errors only.
export const toast = Object.assign(
  (...args: Parameters<typeof originalToast>) => originalToast(...args),
  originalToast,
  {
    error: (...args: Parameters<typeof originalToast.error>) => {
      const [message, options] = args;
      const action = document.querySelector('[role="dialog"]')
        ? undefined
        : { label: 'Ver solução', onClick: openSupportDetails };
      const incident = supportStore.snapshot()[0];
      const matches =
        typeof message === 'string' &&
        incident &&
        message.includes(`[Código: ${incident.support.code}]`);
      if (typeof message === 'string' && !matches && !message.includes('[Código:')) {
        supportStore.record({
          status: 0,
          occurredAt: new Date().toISOString(),
          support: {
            code: 'UI-002',
            technicalCode: 'LOCAL_VALIDATION',
            module: 'Formulários',
            category: 'Validação local',
            title: 'Revise a orientação exibida na tela',
            fields: [],
            steps: [
              'Siga a orientação exibida pelo formulário; nenhum dado preenchido é incluído nestes detalhes.',
              'Se a operação depende de confirmação externa, consulte o histórico antes de tentar novamente.',
            ],
          },
        });
        return originalToast.error(`${message} [Código: UI-002]`, {
          ...options,
          action,
        });
      }
      return originalToast.error(message, {
        ...options,
        ...(matches
          ? {
              duration: 10000,
              action,
            }
          : {}),
      });
    },
  },
);
